export default function SocialProofBar() {
  const logos = [
    { name: "Skool", icon: "ri-community-line" },
    { name: "Facebook", icon: "ri-facebook-fill" },
    { name: "Instagram", icon: "ri-instagram-line" },
    { name: "LinkedIn", icon: "ri-linkedin-fill" },
    { name: "YouTube", icon: "ri-youtube-fill" },
    { name: "TikTok", icon: "ri-tiktok-fill" },
    { name: "Twitter/X", icon: "ri-twitter-x-fill" },
    { name: "Pinterest", icon: "ri-pinterest-fill" },
    { name: "Reddit", icon: "ri-reddit-fill" },
    { name: "WordPress", icon: "ri-wordpress-fill" },
    { name: "Medium", icon: "ri-medium-fill" },
    { name: "Telegram", icon: "ri-telegram-fill" },
  ];

  return (
    <section className="py-14 bg-white border-y border-gray-100">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <p className="text-center text-xs font-semibold text-gray-400 uppercase tracking-widest mb-8">
          Trusted by hundreds of groups, community &amp; business owners — publishing to 30+ Sites in our networks
        </p>

        {/* Scrolling marquee */}
        <div className="relative overflow-hidden">
          <div className="flex items-center gap-8 animate-[marquee_30s_linear_infinite] whitespace-nowrap">
            {[...logos, ...logos].map((net, i) => (
              <div key={i} className="flex items-center gap-2 shrink-0 opacity-50 hover:opacity-80 transition-opacity cursor-default">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className={`${net.icon} text-xl text-gray-600`}></i>
                </div>
                <span className="text-sm font-medium text-gray-600">{net.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
          {[
            { icon: "ri-shield-check-line", text: "SOC 2 Compliant", color: "text-emerald-600 bg-emerald-50" },
            { icon: "ri-lock-line", text: "256-bit SSL Encryption", color: "text-sky-600 bg-sky-50" },
            { icon: "ri-award-line", text: "GDPR Ready", color: "text-violet-600 bg-violet-50" },
            { icon: "ri-time-line", text: "99.9% Uptime SLA", color: "text-amber-600 bg-amber-50" },
          ].map((badge) => (
            <div key={badge.text} className={`flex items-center gap-2 px-4 py-2 rounded-full ${badge.color} text-xs font-semibold`}>
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${badge.icon} text-sm`}></i>
              </div>
              {badge.text}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
